import { useState } from "react";
import { toast } from "sonner";
import { API } from "@/lib/api";

export default function CalendarSync({ memberName }) {
  const [open, setOpen] = useState(false);
  const feeds = [
    { id: "family", label: "Whole family", url: `${API}/ical/stjames.ics`, desc: "Everyone's stays, colour-free but complete." },
    { id: "mine", label: "Just my stays", url: `${API}/ical/${memberName}.ics`, desc: "Only the dates you've booked." },
  ];
  const webcal = (url) => url.replace(/^https?:\/\//, "webcal://");

  const copy = async (url) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied. Paste it in Calendar → Add Subscription.");
    } catch {
      toast.error("Couldn't copy — long-press the link instead.");
    }
  };

  return (
    <div className="mt-8 pt-6 border-t border-[#DCE0D9]" data-testid="calendar-sync">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="calendar-sync-toggle"
        className="flex items-center justify-between w-full text-left min-h-[44px]"
      >
        <span>
          <span className="tracker text-[10px] text-[#5C6B61] block">Calendar sync</span>
          <span className="font-display text-xl text-[#1A2F24]">See StJames in your iPhone calendar</span>
        </span>
        <span className={`font-display text-3xl transition-transform duration-300 ${open ? "rotate-45 text-[#9E473F]" : "text-[#1A2F24]"}`}>+</span>
      </button>

      {open && (
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {feeds.map((f) => (
            <div key={f.id} className="border border-[#DCE0D9] p-4" data-testid={`ical-feed-${f.id}`}>
              <p className="font-display text-lg text-[#1A2F24]">{f.label}</p>
              <p className="font-body text-xs text-[#5C6B61] mt-1">{f.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                <a
                  href={webcal(f.url)}
                  data-testid={`ical-subscribe-${f.id}`}
                  className="bg-[#1A2F24] text-[#FAF9F6] px-4 py-2.5 font-body text-[11px] tracker hover:bg-[#2C4A3A] transition-colors duration-300"
                >
                  Add to iPhone
                </a>
                <button
                  type="button"
                  onClick={() => copy(f.url)}
                  data-testid={`ical-copy-${f.id}`}
                  className="border border-[#1A2F24] text-[#1A2F24] px-4 py-2.5 font-body text-[11px] tracker hover:bg-[#F3F4F1] transition-colors duration-300"
                >
                  Copy link
                </button>
              </div>
            </div>
          ))}
          <p className="sm:col-span-2 font-body text-[11px] text-[#5C6B61]">
            Tap <em>Add to iPhone</em> and choose <em>Subscribe</em>. It refreshes on its own — new bookings show up within an hour.
            On Google Calendar: Settings → Add calendar → From URL → paste the copied link.
          </p>
        </div>
      )}
    </div>
  );
}
